// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

// export const environment = {
//   production: false,
//   dialogFlow: {
//     chatBot: 'c68f84b6805646a59eeee6d77e780303'
//   }
// };

export const Environment = {
    Local: {
        Application:"Lease CRM Operation Local",
        production: false,
        Env: 'Local-',
        CloudApiHost: 'http://localhost:7300/leasecloud',
        AccountApiHost: "http://localhost:5000/account",
        SocketEndpoint: 'http://localhost:5050',
        InputDateFormat: "DD/MM/YYYY",
    },
    Dev: {
        Application:"Lease CRM Operation",
        production: false,
        Env: 'Dev-',
        CloudApiHost: 'https://dev.rentx.my/leasecloud',
        AccountApiHost: "https://dev.rentx.my/account",
        SocketEndpoint: 'https://dev.rentx.my/',
        InputDateFormat: "DD/MM/YYYY",
    },
    Uat: {
        Application:"Lease CRM Operation",
        production: false,
        Env: 'Uat-',
        CloudApiHost: 'https://dev.rentx.my/leasecloud',
        AccountApiHost: "https://dev.rentx.my/account",
        SocketEndpoint: 'https://dev.rentx.my/',
        InputDateFormat: "DD/MM/YYYY",
    },
    Prod: {
        Application:"Lease CRM Operation",
        production: false,
        Env: '',
        CloudApiHost: 'https://api.lease365.my/lease',
        AccountApiHost: "https://api.lease365.my/account",
        SocketEndpoint: 'https://api.lease365.my/',
        InputDateFormat: "DD/MM/YYYY",
    }
};


export const environment = Environment.Dev;
